import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, IconAsButton, theme, Typo } from '../../ui';
import { useTranslation } from 'react-i18next';

const NotificationsItemWrapper = styled.li`
  list-style-type: none;
  border-bottom: 0.5px solid ${(props) => props.theme.colors.NEU_600};
  padding: 25px 20px;
  cursor: pointer;

  ${({ $isNew, theme }) =>
    $isNew === true && css`
      background-color: ${theme.colors.NEU_50};
      border-left: 3px solid ${theme.colors.PRIMARY};
    `
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.PRIMARY};
    outline-offset: 2px;
  }

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

const NotificationItem = ({ info, selectClick }) => {
  const { t } = useTranslation();
  const { message, isRead, created } = info;

  const handleClick = (e) => {
    if (isRead) return;
    if (e.target instanceof HTMLAnchorElement) {
      e.preventDefault();
      selectClick();
      setTimeout(() => {
        window.location.href = e.target.href;
      }, 100);
    } else {
      selectClick();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(e);
    }
  };

  return (
    <NotificationsItemWrapper
      $isNew={isRead === 0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={isRead !== 0}
    >
      <Flex justify='space-between'>
        <Flex direction='column' gap='5' align='flex-start'>
          <time dateTime={new Date(created).toISOString()}>
            <Typo.Info>{created}</Typo.Info>
          </time>
          <Typo.MediumText
            fontWeight={isRead === 0 ? '600' : undefined}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </Flex>
        <IconAsButton
          color={theme.colors.PRIMARY}
          clickHandle={(e) => {
            e.stopPropagation();
            selectClick();
          }}
          tooltipLabel={isRead === 0 ? t('notifications.archive') : t('notifications.unarchive')}
          iconName={isRead === 0 ? 'Archive' : 'Unarchive'}
        />
      </Flex>
    </NotificationsItemWrapper>
  );
};

export default NotificationItem;
